import runtimeConfig from '../../runtimeConfig';
import angularHost from './angularHost';
import mockAngularHost from './__mocks__';

export function getAngularHost() : AngularHost {
    return runtimeConfig.shouldMockAngular() ? mockAngularHost : angularHost;
}

export default getAngularHost();
